import React, { useState, useEffect } from 'react';
import VerticalBarChart from '../components/VerticalBarChart';
import qeAndRndIntensityService from './qe_and_rnd_intensity.service';
const TotalQEAndIntensity = _ref => {
  let {
    filteredBusinessUnits = [],
    selectedYears = [],
    selectedSubsidiaryCompanyIds = [],
    companyId
  } = _ref;
  const [chartData, setChartData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      const buIds = filteredBusinessUnits.map(bu => bu.business_unit_id).join(',');
      const scIds = selectedSubsidiaryCompanyIds.join(',');
      const data = await qeAndRndIntensityService.all(companyId, buIds, scIds, selectedYears);
      setChartData(data);
    };
    fetchData();
  }, [companyId, filteredBusinessUnits, selectedSubsidiaryCompanyIds]);
  const QEData = [{
    label: 'Secure QE (£)',
    value: Math.round(Number((chartData === null || chartData === void 0 ? void 0 : chartData.total_rnd_amount) || 0))
  }];
  const intensityData = [{
    label: 'R&D Intensity',
    value: Number(chartData.avg_eligible_rnd_percentage || 0)
  }];
  const percantegeFormatter = value => {
    return value.toFixed(1) + '%';
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "dashboard-card"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-center dashboard-regular-card-title mb-1"
  }, "Current QE & R&D Intensity"), /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-center gap-0"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1,
      maxWidth: '400px'
    }
  }, /*#__PURE__*/React.createElement(VerticalBarChart, {
    data: QEData,
    dataName: "Secure QE",
    lablePosition: "left",
    colors: ['#00afef']
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1,
      maxWidth: '400px'
    }
  }, /*#__PURE__*/React.createElement(VerticalBarChart, {
    data: intensityData,
    dataName: "Current QE & R&D Intensity",
    colors: ['#0078b9'],
    opposite: true,
    formatter: percantegeFormatter,
    isPercentageData: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-center"
  }, "Total"));
};
export default TotalQEAndIntensity;